module.exports = __webpack_public_path__ + "static/media/zo.f2cea72e.png";